import { ConnectStores } from "lib/core/store"
import { DESIGN, LEARN, TEACH } from "path/constants"
import withAvailableModes from "../path/withAvailableModes"
import FacilitatorList from "./FacilitatorList"

const mapStateToProps = function (state, ownProps) {
  const { user } = state.authStore.state
  const { mode, viewing_as_learner } = state.pathStore.state
  const { facilitators } = state.memberStore.state
  const { offering } = state.resourceStore.state

  const { availableModes } = ownProps

  const permissions = state.resourceStore.request.permissions()
  const isCurriculum = offering != null ? offering.is_curriculum : undefined

  const canViewCard = permissions != null ? permissions.can_access : undefined

  // assuming staff shape: { id, user, role }
  let staffList = facilitators

  const showInviteButton =
    mode === DESIGN ||
    mode === TEACH ||
    (mode <= LEARN &&
      !viewing_as_learner &&
      !!user &&
      !!offering &&
      // allowing moderators+ OR cohort creator to see invite button
      (availableModes.includes(TEACH) || offering.created_by_id === user.id))

  return _.assign(
    {},
    {
      staffList,
      showInviteButton,
      canViewCard,
      isCurriculum
    },
    ownProps
  )
}

const stores = [
  { store: "auth", watch: false },
  { store: "path", watch: ["mode"] },
  { store: "resource", watch: ["offering"] },
  { store: "member", watch: ["facilitators", "facilitators_loading", ""] }
]

export default withAvailableModes(
  ConnectStores(FacilitatorList, stores, {}, mapStateToProps)
)
